import { ApiBase } from '@/libs/apis/base';

export class InternalNotificationsApiBase extends ApiBase {
  constructor(vue, path = '') {
    super(vue, `notifications/internal${path}`, true);
    this.errorName = 'InternalNotificationsApiError';
  }
}
